export const SectionItem = {
    ITEM_TYPE_FIELD : 1,
    ITEM_TYPE_RESULT : 2,
    OUTCOME_TYPE_POSITIVE : 1,
    OUTCOME_TYPE_NEGATIVE : 2
}
